export const LoginStatus = Object.freeze({
	LOGIN_SUCCESS: "LOGIN_SUCCESS",
	REFRESH_SUCCESS: "REFRESH_SUCCESS",
	INVALID_REFRESH_TOKEN: "INVALID_REFRESH_TOKEN",
	PASSWORD_EXPIRED: "PASSWORD_EXPIRED",
	BAD_REQUEST: "BAD_REQUEST",
});

export default LoginStatus;
